import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';

import { MoteService, ProjectService, UserMoteService, UserProjectService } from '../../../providers';
import { Mote, Project } from '../../../models';
import { MotesLoginService } from '../../../motes-login';

@Component({
    selector: 'auto-complete-motes',
    templateUrl: './auto-complete-motes.component.html',
    styleUrls: ['./auto-complete-motes.component.scss']
})
export class AutoCompleteMotesComponent {

    @Output() selectedMotesChanged = new EventEmitter<Mote[]>();
    @Input() set initSelectedMotes(motes: Array<Mote>) {
        // Init mote list with motes already in list (OBS this will happen every time an change is emitted)
        // Make of slice copy of array (otherwise functions like pop() will change the original array)
        this.selectedMotes = motes.slice(0);
    }
    @Input() style: 'no-bg' | 'draw-bg' = 'draw-bg';
    @Input() loadAllMotes: boolean = false;

    // List of user selected / project motes
    public selectedMotes: Array<Mote> = [];
    // Observable to be used in autocompletion list
    public motesObservable;
    // Filter function to select motes
    public filterFunction;

    constructor(private userProjectService: UserProjectService, private moteService: MoteService) {
        // Wrap filter function in ES6 container in order to preserve conrext
        this.filterFunction = (mote, idx, searchString) => this.filterMotes(mote, idx, searchString);
    }

    public ngOnInit() {
        if(this.loadAllMotes) {
            this.motesObservable = this.moteService.watchAllMotes();
        }
        else {
            this.motesObservable = this.userProjectService.watchUserProjectMotes();
        }
    }

    public moteSelected(mote: Mote) {
        this.selectedMotes.push(mote);
        this.selectedMotesChanged.emit(this.selectedMotes);
    }

    public moteUnselected(rmMote: Mote) {
        this.selectedMotes = this.selectedMotes.filter((mote: Mote) => {
            // Remove mote from list (return false if this is the one to be remove)
            return !(mote.key == rmMote.key);
        });
        this.selectedMotesChanged.emit(this.selectedMotes);
    }

    public queryDeleted() {
        if(this.selectedMotes.length <= 0) return;
        // Delete last entry in list of owners
        this.selectedMotes.pop();
        this.selectedMotesChanged.emit(this.selectedMotes);
    }

    public filterMotes(mote: Mote, idx: number, searchString: string): boolean {
        //console.log("Filter ", searchString);
        if(!searchString || idx >= 100000) return false;
        // Filter away motes that are already owned by this project
        if(this.selectedMotes.find((searchMote) => searchMote.key == mote.key)) return false;

        if(searchString == "*") return true;

        // Only seatch form key if query starts with key:
        if(searchString.startsWith("key:")) {
            let key = searchString.replace("key:", "").trim();
            //console.log("Filter mote ", mote.key);
            return key != "" && mote.key == key;
        }

        // Include key in general search
        if(mote.key == searchString) return true;

        // Search without case sensitivity
        let query = searchString.toLocaleLowerCase();
        // Test of queryuery has wildcard character at beginning
        let wildcard = query.startsWith("*");
        query = query.replace("\*", "");

        // Filter on mote project key
        if(mote.project == "" && query == "none") return true;
        if(mote.project.startsWith(query)) return true;

        // Search for string matches (by default only from beginning of string)
        if(wildcard)
            return mote.title.toLowerCase().includes(query);
        else
            return mote.title.toLowerCase().startsWith(query);
    }
}
